<template>
  <v-container fluid>
    <v-parallax 
    :src="require('@/assets/compass.jpg')"
    aspect-ratio="1.7"
    height="300"
    class="my-2">
      <v-layout align-center justify-space-around row wrap fill-height>
        <h1 class="display-3 font-weight-thin white--text ma-2">我们的服务</h1>
      </v-layout>
    </v-parallax>
    <v-layout row wrap>
      <v-flex class="my-4">
        <v-layout row wrap 
        text-xs-center 
        justify-center
        class="my-2">
          <h1 class="display-2 font-weight-thin my-2">并购和融资</h1>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 md6>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-parallax
                  :src="require('@/assets/handshakecolor.jpg')"
                  >
                    <v-container fill-height>
                      <v-layout align-center>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <div class="shadow">
                              <h1 class="display-2 font-weight-thin white--text">兼并与收购</h1>
                              <h2 class="display-5 font-weight-thin white--text">公司的全部或部分收购，合并或出售。</h2>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-parallax>

                  <v-card-title primary-title>
                    <div>
                      <div class="headline ml-2">差异化的战略和战术建议以及有效的执行：
                        <v-spacer></v-spacer>
                        <v-btn flat  @click="showMAD = !showMAD">
                          <div>{{ showMAD ? '阅读更少' : '阅读更多' }}</div>
                        </v-btn>
                        <v-btn icon @click="showMAD = !showMAD">
                          <v-icon>{{ showMAD ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                        </v-btn>
                      </div>
                      <v-slide-y-transition>
                        <v-list three-line
                        v-show="showMAD">
                          <template v-for="(maDetail, i) in maDetails">

                            <v-list-tile
                              :key="i"
                              avatar
                              class="my-2"
                            >
                              <v-list-tile-avatar>
                                <v-icon color="accent">{{maDetail.icon}}</v-icon>
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-list-tile-title>{{maDetail.title}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{maDetail.subtitle}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                        </v-list>
                      </v-slide-y-transition>
                    </div>
                  </v-card-title>
                  
                  <v-card-actions>
                    <v-layout 
                    align-center 
                    justify-center 
                    row wrap 
                    fill-height
                    class="mb-2">
                      <v-btn 
                      color="accent"
                      class="white--text"
                      :to="'/cn/contact'">联系我们</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex sm12 md6>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-parallax
                  :src="require('@/assets/singaporecolor.jpg')"
                  >
                    <v-container fill-height>
                      <v-layout align-center>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <div class="shadow">
                              <h1 class="display-2 font-weight-thin white--text">资本筹集</h1>
                              <h2 class="display-5 font-weight-thin white--text">直接私募股权，信贷或混合融资解决方案 </h2>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-parallax>

                  <v-card-title primary-title>
                    <div>
                      <div class="headline ml-2">我们依靠丰富的复杂交易执行经验来帮助实现您的目标，包括：
                        <v-spacer></v-spacer>
                        <v-btn flat  @click="showCRD = !showCRD">
                          <div>{{ showCRD ? '阅读更少' : '阅读更多' }}</div>
                        </v-btn>
                        <v-btn icon @click="showCRD = !showCRD">
                          <v-icon>{{ showCRD ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                        </v-btn>
                      </div>
                      <v-slide-y-transition>
                        <v-list three-line
                        v-show="showCRD">
                          <template v-for="(crDetail, i) in crDetails">

                            <v-list-tile
                              :key="i"
                              avatar
                              class="my-2"
                            >
                              <v-list-tile-avatar>
                                <v-icon color="accent">{{crDetail.icon}}</v-icon>
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-list-tile-title>{{crDetail.title}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{crDetail.subtitle}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                        </v-list>
                      </v-slide-y-transition>
                    </div>
                  </v-card-title>
                  
                  <v-card-actions>
                    <v-layout 
                    align-center 
                    justify-center 
                    row wrap 
                    fill-height
                    class="mb-2">
                      <v-btn 
                      color="accent"
                      class="white--text"
                      :to="'/cn/contact'">联系我们</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        showMAD: true,
        showCRD: true,
        maDetails: [
          {
            icon: 'assignment_turned_in',
            title: '交易评估',
            subtitle: '我们评估潜在目标，提供估值分析，评估和提出财务和战略选择。'
          },
          {
            icon: 'question_answer',
            title: '独立建议',
            subtitle: '我们为董事会和管理团队提供独立判断和深厚的行业和地理专业知识。'
          },
          {
            icon: 'gavel',
            title: '交易执行',
            subtitle: '我们还建议拟议交易的时间，结构，融资和定价，以及协助谈判和完成交易。'
          }
        ],
        crDetails: [
          {
            icon: 'work',
            title: '私募股权销售',
            subtitle: '私营公司的传统和首次公开募股前股权配售以及股东更换。'
          },
          {
            icon: 'trending_up',
            title: '成长资本',
            subtitle: '与收购相关的私募股权或债务融资以及项目融资。'
          },
          {
            icon: 'autorenew',
            title: '资本重组',
            subtitle: '公司股权资本重组/债务再融资，主权债务再融资，上市公司的私人投资(“PIPEs”)。'
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .shadow {
    position: absolute;
    top: 30%;
    left: 0;
    background-color: rgba(0,0,0,0.5);
    color: white;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/fuwu.vue